var ENGLISH = {};
"a bcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-"
  .split("")
  .forEach(function (ch) {
    ENGLISH[ch] = true;
  });

var FARSI = {};

"آ ا ب پ ت ث ج چ ح خ د ذ ر ز ژ س ش ص ض ط ظ ع غ ف ق ک گ ل م ن و ه ی ئ ۱ ۲ ۳ ۴ ۵ ۶ ۷ ۸ ۹۰-"
  .split("")
  .forEach(function (ch) {
    FARSI[ch] = true;
  });

function RightLeftChecker(str) {
  if (str && FARSI[str[0]]) {
    return true;
  } else {
    return false;
  }
}
export default RightLeftChecker;
